import { render, staticRenderFns } from "./JourneyGroupItem.vue?vue&type=template&id=036e9be4&scoped=true&"
import script from "./JourneyGroupItem.vue?vue&type=script&lang=js&"
export * from "./JourneyGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e9be4",
  null
  
)

export default component.exports